"use client";
import LiveChat from "@/components/LiveChat/LiveChat";
import Newsletter from "@/components/Newsletter";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import ClockIcon from "@/icons/AlarmIcon";
import LiveChatIcon from "@/icons/ChatIcon";
import {
  CopyRightFooter,
  ResourcesLink,
  shoppingToolLinks,
  socialMediaLinks,
  StaticLink,
} from "@/lib/constant";
import { AddNewBreadcrum } from "@/redux/slices/breadcrumSlice";
import Image from "next/image";
import Link from "next/link";
import { useDispatch } from "react-redux";

const Footer = () => {
  const dispatch = useDispatch();
  const updateBreadcrumb = (breadCrumb) =>
    dispatch(AddNewBreadcrum(breadCrumb));
  return (
    <div className="border-t border-[#D2D2D7]">
      {/* <TopReasons /> */}
      <footer className=" max-w-[1778px] px-5   mx-auto my-0 pt-[32px] ">
        <div className="flex gap-2 justify-between pb-[30px] mxl:grid mxl:grid-cols-6 gap-y-5 smd:flex smd:flex-col">
          <div className="w-[308px]  mxl:row-start-2 mxl:col-start-1 mxl:col-end-4 mxl:w-full text-[15px] leading-[22px]">
            <h3 className=" text-blue3  font-bold mb-3 uppercase ">
              Sales and Customer Service
            </h3>
            <div className=" text-blue5 mb-4 inline-flex gap-[5px] items-center cursor-pointer">
              <LiveChatIcon fill=" black" /> <LiveChat /> |{" "}
              <span className=" text-black3">
                <a href="tel:+18663044449" aria-label="call +18663044449">
                  (866) 304-4449
                </a>
              </span>{" "}
              |{" "}
              <a href="/contact" aria-label="Email Us">
                Email
              </a>
            </div>
            <h3 className=" text-blue3  font-bold mb-3 uppercase ">
              Customer Service Weekly Hours
            </h3>
            <div className=" mb-6 flex  gap-[5px]">
              <ClockIcon />
              <div>
                <p className=" text-blue5">Mon - Fri: 8:00 AM to 7:00 PM PST</p>
                <p className=" text-blue5">Sat - Sun: 9:00 AM to 6:00 PM PST</p>
              </div>
            </div>
            <h3 className=" text-blue3  font-bold mb-5 uppercase ">
              <Link href={"/stores"}>Store Hours & Locations</Link>
            </h3>
            <h3 className=" text-blue3  font-bold mb-5 uppercase ">
              Follow us on
            </h3>
            <div className="flex gap-[10px]">
              {socialMediaLinks?.map((link, index) => (
                <Link href={link.href} key={index} target="_blank">
                  <Image src={link.imgSrc} alt={link.alt} />
                </Link>
              ))}
            </div>
          </div>
          <Accordion
            type="single"
            collapsible
            className="w-full hidden smd:block"
          >
            <AccordionItem
              value="item-1"
              className="bg-[#F6F6F6] border-none rounded-[8px] mb-2"
            >
              <AccordionTrigger className=" px-5 text-[#0C2340] text-[14px] uppercase font-medium">
                <span>COMPANY INFO</span>
              </AccordionTrigger>
              <AccordionContent className=" px-5 ">
                <ul className=" text-black text-sm  flex flex-col gap-3">
                  {StaticLink.map(({ href, label }, index) => (
                    <Link key={index} href={href}>
                      {label}
                    </Link>
                  ))}
                </ul>
              </AccordionContent>
            </AccordionItem>
            <AccordionItem
              value="item-2"
              className="bg-[#F6F6F6] border-none rounded-[8px] mb-2"
            >
              <AccordionTrigger className=" px-5 text-[#0C2340] text-[14px] uppercase font-medium">
                SHOPPING TOOLS
              </AccordionTrigger>
              <AccordionContent className="px-5">
                <ul className=" text-black text-sm flex flex-col gap-3">
                  {shoppingToolLinks.map(({ href, label }, index) => (
                    <Link
                      key={index}
                      href={href}
                      target={label === "Mandarin" ? "_blank" : undefined}
                      rel={
                        label === "Mandarin" ? "noopener noreferrer" : undefined
                      }
                      onClick={() =>
                        updateBreadcrumb([
                          {
                            name: label === "Shop Outlet" ? "Outlet" : label,
                            url: href,
                          },
                        ])
                      }
                    >
                      {label}
                    </Link>
                  ))}
                </ul>
              </AccordionContent>
            </AccordionItem>
            <AccordionItem
              value="item-3"
              className="bg-[#F6F6F6] border-none rounded-[8px]"
            >
              <AccordionTrigger className=" px-5 text-[#0C2340] text-[14px] uppercase font-medium">
                RESOURCES
              </AccordionTrigger>
              <AccordionContent className="px-5">
                <ul className=" text-black text-sm flex flex-col gap-3">
                  {ResourcesLink.map(({ href, label }, index) => (
                    <Link key={index} href={href}>
                      {label}
                    </Link>
                  ))}
                </ul>
              </AccordionContent>
            </AccordionItem>
          </Accordion>
          <div className=" smd:hidden w-[235px] mxl:w-full mxl:col-start-1 mxl:col-end-3 ">
            <h3 className=" text-blue3  font-bold mb-3 pb-3 uppercase ">
              COMPANY INFO
            </h3>
            <ul className=" text-black text-sm flex flex-col gap-3">
              {StaticLink.map(({ href, label }, index) => (
                <Link key={index} href={href}>
                  {label}
                </Link>
              ))}
            </ul>
          </div>
          <div className="smd:hidden w-[235px] mxl:w-full  mxl:col-start-3 mxl:col-end-5">
            <h3 className=" text-blue3  font-bold mb-3 pb-3 uppercase ">
              SHOPPING TOOLS
            </h3>
            <ul className=" text-black text-sm flex flex-col gap-3">
              {shoppingToolLinks.map(({ href, label }, index) => (
                <Link
                  key={index}
                  href={href}
                  target={label === "Mandarin" ? "_blank" : undefined}
                  rel={label === "Mandarin" ? "noopener noreferrer" : undefined}
                  onClick={() =>
                    updateBreadcrumb([
                      {
                        name: label === "Shop Outlet" ? "Outlet" : label,
                        url: href,
                      },
                    ])
                  }
                >
                  {label}
                </Link>
              ))}
            </ul>
          </div>
          <div className="smd:hidden w-[235px] mxl:w-full  mxl:col-start-5 mxl:col-end-7">
            <h3 className=" text-blue3  font-bold mb-3 pb-3 uppercase ">
              RESOURCES
            </h3>
            <ul className=" text-black text-sm flex flex-col gap-3">
              {ResourcesLink.map(({ href, label }, index) => (
                <Link key={index} href={href}>
                  {label}
                </Link>
              ))}
            </ul>
          </div>
          <Newsletter />
        </div>
        <div className="text-center text-black flex justify-center flex-col  gap-[10px] py-[15px] items-center border-t border-gray-15">
          <p className=" text-[15px] leading-[22px]">
            Copyright © 2009 - 2025 <b>Airport Home Appliance</b> All Rights
            Reserve.
          </p>
          <p className=" text-[15px] leading-[22px]">
            {CopyRightFooter.map(({ href, label }, index) => (
              <span key={index}>
                <Link href={href} className="cursor-pointer">
                  {label}
                </Link>
                {index < CopyRightFooter.length - 1 && " | "}
              </span>
            ))}
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
